import React from 'react';
import styled from 'styled-components';
import { Glyphicon } from 'react-bootstrap';
import { string } from 'prop-types';
import ContainedButton from './index';
import {OnAccentColor} from '../../Colors';

const Icon = styled(Glyphicon)`
    color : ${props => props.color};
    font-size : ${props => props.fontSize};
`;

const AddButton = ({color=OnAccentColor,fontSize='1rem',...props}) => (
	<ContainedButton {...props}>
		<Icon color={color} fontSize={fontSize} glyph="plus"></Icon>
	</ContainedButton>);

AddButton.propTypes = {
	color: string,
	fontSize: string
};


export default AddButton;